module.exports = __webpack_public_path__ + "img/truck.e3ffade0.png";